import { BaseQueryFn } from '@reduxjs/toolkit/query';
import { FetchBaseQueryArgs } from '@reduxjs/toolkit/query';
import { API_ENDPOINT } from 'api/constants';
import axios, { AxiosError, AxiosRequestConfig } from 'axios';

import { tagCacheService } from '../cache/TagCacheService';

const axiosBaseQuery = (
  { baseUrl }: { baseUrl: string } = { baseUrl: API_ENDPOINT },
): BaseQueryFn<
  {
    url: string;
    method: AxiosRequestConfig['method'];
    params?: Record<string, unknown>;
    body?: AxiosRequestConfig['data'];
    requiresAuth?: boolean;
    searchParams?: Record<string, unknown>;
  },
  unknown,
  unknown
> => async (props) => {
  const { url, method, body, requiresAuth, params, searchParams } = props;

  let fullUrl = baseUrl + url;

  if (requiresAuth) {
    let token = localStorage.getItem('token');
    const eroGuestId = localStorage.getItem('ero_guest_id');

    if (token || eroGuestId) {
      const urlObj = new URL(fullUrl);

      if (token) {
        token = decodeURIComponent(token);
        urlObj.searchParams.append('token', token);
      }

      if (eroGuestId) {
        urlObj.searchParams.append('ero_guest_id', eroGuestId);
      }

      if (searchParams) {
        Object.entries(searchParams).forEach(([key, value]) => {
          urlObj.searchParams.append(key, String(value));
        });
      }

      fullUrl = urlObj.toString();
    }
  }

  try {
    const tagMatch = url.match(/\/tags\/([^\/]+)/);
    if (method === 'GET' && tagMatch) {
      const tagName = tagMatch[1];
      const data = await tagCacheService.getTagData(tagName);
      if (!data) {
        return {
          error: { status: 404, data: 'Tag not found' }
        };
      }
      return { data };
    }

    const result = await axios({
      url: fullUrl,
      method,
      data: body,
      params,
    });

    return { data: result.data };
  } catch (axiosError) {
    const err = axiosError as AxiosError;
    return {
      error: { status: err.response?.status, data: err.response?.data },
    };
  }
};

export const createBaseQuery = (options: Partial<FetchBaseQueryArgs> = {}) =>
  axiosBaseQuery({ baseUrl: API_ENDPOINT, ...options });
